"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _underscore = _interopRequireDefault(require("underscore"));

var _reactBootstrap = require("react-bootstrap");

var _close = _interopRequireDefault(require("@parchment/ui-icons/lib/ai/close-1"));

require("./Popover.less");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Popover = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(Popover, _React$Component);

  var _super = _createSuper(Popover);

  function Popover(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Popover);
    _this = _super.call(this, props);
    _this.close = _this.close.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(Popover, [{
    key: "close",
    value: function close(e) {
      this.props.onCloseClick(e);
    }
  }, {
    key: "renderTitle",
    value: function renderTitle() {
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", null, this.props.title), this.props.showClose && /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
        className: "close-btn",
        bsStyle: "link",
        onClick: this.close
      }, /*#__PURE__*/_react.default.createElement(_close.default, {
        noPad: true
      })));
    }
  }, {
    key: "render",
    value: function render() {
      var className = "primitive-popover ".concat(this.props.className || '');
      return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Popover, (0, _extends2.default)({}, _underscore.default.omit(this.props, 'showClose', 'onCloseClick', 'title', 'className'), {
        title: this.renderTitle(),
        className: className
      }));
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return {
        showClose: _propTypes.default.bool,
        // called as a callback when the close button is clicked
        onCloseClick: _propTypes.default.func
      };
    }
  }, {
    key: "defaultProps",
    get: function get() {
      return {
        showClose: false,
        onCloseClick: _underscore.default.noop
      };
    }
  }]);
  return Popover;
}(_react.default.Component);

exports.default = Popover;